"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCardStyles = void 0;
const Utils_1 = require("../../../utils/Utils");
exports.getCardStyles = (0, Utils_1.createStyleSheet)((theme) => ({
    default: Object.assign({}, theme.variants.cards.default),
}), { name: 'Blueprint-Card' });
